module.exports = __webpack_public_path__ + "f85ef4e28c7fec15cb65774262002f9d.svg";